import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import logo from '../assets/images/Logo.png';
import { FaHospital, FaUserMd, FaUserShield, FaSignOutAlt } from 'react-icons/fa';
import { BiMenu } from 'react-icons/bi';
import { useAuth } from '../context/AuthContext';

function DashboardHeader({ userType = 'hospital', userName = 'City General Hospital', onMenuClick }) {
  const navigate = useNavigate();
  const { logout, user } = useAuth(); // ✅ single call

  const getImageMimeType = (fileName) => {
    if (!fileName) return "image/jpeg";
    const ext = fileName.split(".").pop()?.toLowerCase();
    if (ext === "png") return "image/png";
    if (ext === "jpg" || ext === "jpeg") return "image/jpeg";
    if (ext === "webp") return "image/webp";
    return "image/jpeg";
  };

  const photoSrc = user?.photoFileBytes
    ? `data:${getImageMimeType(user?.photoFileName)};base64,${user.photoFileBytes}`
    : null;

  const getLogoutRoute = () => '/login';

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
      navigate(getLogoutRoute());
    }
  };

  return (
    <div className="header-sticky-wrapper">
      <header className="main-header">
        <nav className="navbar navbar-expand-lg py-1 navbar-light">
          <div className="container-fluid">

            {/* Logo */}
            <a className="navbar-brand me-5" href="#">
              <img src={logo} alt="24/7 ProCare Logo" className="logo-img" />
            </a>

            {/* User Name and Logout */}
            <div className="d-flex align-items-center ms-auto gap-3">
              <div className="d-flex align-items-center gap-2">

                {/* ✅ Profile Photo OR Initials */}
                {photoSrc ? (
                  <img
                    src={photoSrc}
                    alt="Profile"
                    className="rounded-circle"
                    style={{
                      width: "40px",
                      height: "40px",
                      objectFit: "cover",
                      border: "2px solid #0d6efd",
                    }}
                  />
                ) : (
                  <div
                    className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                    style={{
                      width: "40px",
                      height: "40px",
                      fontWeight: "bold",
                      fontSize: "18px",
                      userSelect: "none",
                    }}
                  >
                    {userName ? userName.substring(0, 2).toUpperCase() : ""}
                  </div>
                )}

                <span className="hospital-name-text">{userName}</span>
              </div>

              {/* Dropdown menu */}
              <div className="dropdown">
                <button
                  className="btn btn-light dropdown-toggle"
                  type="button"
                  id="userDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ minWidth: 0, padding: '0.375rem 0.75rem' }}
                >
                  <BiMenu className="me-2" /> Menu
                </button>

                <ul
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby="userDropdown"
                  style={{ minWidth: '180px' }}
                >
                  {/* Admin Menu Items */}
                  {userType === 'admin' && (
                    <>
                      <li><Link className="dropdown-item" to="/admin/dashboard">Admin Dashboard</Link></li>
                      <li><Link className="dropdown-item" to="/admin/patients">Patient List</Link></li>
                      <li><Link className="dropdown-item" to="/admin/visit-requests">Visit Requests</Link></li>
                      <li><Link className="dropdown-item" to="/admin/hospitals">List of Hospitals</Link></li>
                      <li><Link className="dropdown-item" to="/admin/registered-professionals">List of Professionals</Link></li>
                      <li><Link className="dropdown-item" to="/admin/qualifications">Doctor Qualifications</Link></li>
                      <li><Link className="dropdown-item" to="/admin/posting-by-hospitals">Posting by Hospitals</Link></li>
                      <li><Link className="dropdown-item" to="/admin/time-sheet-approval">Time Sheet Approval</Link></li>
                      <li><Link className="dropdown-item" to="/admin/update-password">Update Password</Link></li>
                      <li><hr className="dropdown-divider" /></li>
                    </>
                  )}

                  {/* Hospital Menu Items */}
                  {userType === 'hospital' && (
                    <>
                      <li><Link className="dropdown-item" to="/hospital-dashboard">Job Requirements</Link></li>
                      <li><Link className="dropdown-item" to="/hospital-profile">Hospital Profile</Link></li>
                      <li><hr className="dropdown-divider" /></li>
                    </>
                  )}

                  {/* Professional Menu Items */}
                  {userType === 'professional' && (
                    <>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            if (onMenuClick) onMenuClick('opportunities');
                          }}
                        >
                          Consultant Opportunities
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            if (onMenuClick) onMenuClick('applied');
                          }}
                        >
                          Applied Requests
                        </a>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/professional-visit-requests">
                          Visit Requests
                        </Link>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            if (onMenuClick) onMenuClick('modify-profile');
                          }}
                        >
                          Modify Profile
                        </a>
                      </li>
                      <li><hr className="dropdown-divider" /></li>
                    </>
                  )}

                  {/* Logout */}
                  <li>
                    <button className="dropdown-item text-danger" onClick={handleLogout}>
                      <FaSignOutAlt className="me-2" />Logout
                    </button>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </nav>
      </header>
    </div>
  );
}

export default DashboardHeader;
